import { z } from "zod";

//QualidadeProvisaoRecursoSchema
const optionalValor = z.coerce.string().nullable().default(null).transform(x => {
  
  return x !== null && x !== undefined && x.trim().length > 0 ? Number(x) : null;
});
const optionalDate = z.coerce.date().nullable().optional();

export const QualidadeProvisaoRecursoSchema = z.object({
  IdProvisaoRecurso: z.number().optional(),
  Recurso: z.string().min(1, "O campo Recurso é obrigatório"),
  Observacao: z.string().nullable().optional(),
  DataPrevistaAte: optionalDate,
  DataPrevistaDe: optionalDate,
  DataRealizadaAte: optionalDate,
  DataRealizadaDe: optionalDate,
  ValorPrevisto: optionalValor, 
  ValorDesembolsado: optionalValor,


  //Extra
  DataPrevista: optionalDate,
  DataRealizada: optionalDate,
  
});

// QualidadeProvisaoRecursoForm

export type QualidadeProvisaoRecursoForm = z.infer<typeof QualidadeProvisaoRecursoSchema>;

export const ReportProvisaoRecursoSchema = z.object({
  DataPrevista: optionalDate,
  DataRealizada: optionalDate,
  
});

// QualidadeProvisaoRecursoForm

export type ReportProvisaoRecursoForm = z.infer<typeof ReportProvisaoRecursoSchema>;